import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { useCampaigns } from "api/campaigns";
import { useEvents } from "api/events";
import { useAppSelector } from "app/hooks";
import { Breadcrumbs, TopHeader } from "components/Header/TopHeader/TopHeader";
import { sortCampaignTranslations } from "components/Layout/Campaign/Common/campaignHelpers";
import { prepareInitialValues } from "components/Layout/Campaign/utils/utils";
import { OLTheme } from "contexts/Theme/ThemeProvider";
import { useMessage } from "hooks/intl";
import { useParams } from "react-router-dom";
import { selectDefaultLanguageData } from "reduxState/translations/translationsSlice";
import { CampaignFEValues, CampaignTriggers } from "types/campaigns";
import { links } from "utilities/links";
import ReferralsForm from "./ReferralsForm";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    formContainer: {
      maxWidth: "872px",
      margin: `${theme.spacing(8)} auto 0`,
    },
  }),
);

export function EditReferral() {
  const classes = useStyles();
  const { message } = useMessage();
  const { useCampaignData } = useCampaigns();
  const { useCustomEventSchemaDetails } = useEvents();
  const { id: campaignID } = useParams<{ id: string }>();
  const { data: campaignData } = useCampaignData(campaignID as string);

  const defaultLang = useAppSelector(selectDefaultLanguageData);

  const { data: selectedSchemaDetails } = useCustomEventSchemaDetails(
    campaignData &&
      "event" in campaignData &&
      campaignData.trigger !== CampaignTriggers.INTERNAL_EVENT
      ? campaignData.event
      : undefined,
  );

  const initialValues = campaignData
    ? {
        ...prepareInitialValues({
          campaignData,
          selectedSchemaDetails,
        }),
        translations: sortCampaignTranslations(
          defaultLang?.code,
          campaignData?.translations || [],
        ),
      }
    : {};

  const breadcrumbs: Breadcrumbs = {
    parent: {
      label: message({ id: "referrals" }),
      path: links.referralsList,
    },
  };

  return (
    <>
      <TopHeader
        title={
          campaignData
            ? `${message({ id: "editReferral" })} "${campaignData?.name}"`
            : ""
        }
        clearLink={links.referralsList}
        breadcrumbs={breadcrumbs}
      />
      <div className={classes.formContainer}>
        {campaignData && (
          <ReferralsForm
            initialValues={initialValues as CampaignFEValues}
            isEditMode
            campaignId={campaignID}
          />
        )}
      </div>
    </>
  );
}
